import axios from "axios";
const apiCumbres = axios.create({
    //baseURL : 'http://localhost:3012/api-cumbres',
    baseURL : 'https://api-cumbres.codiceinnova.com/api-cumbres',
    headers: {
        'Accept': 'application/x-www-form-urlencoded',
        'Content-Type': 'application/x-www-form-urlencoded',
    }
})

export default apiCumbres
